<template>
  <div ref="mega-menu" :class="elementContainerClasses" :style="elementContainerStyles" class="wf-absolute wf-right-0">
    <div class="wf-container wf-mx-auto">
      <div class="wf-flex wf-flex-wrap wf--mx-2">
        <div v-for="child in children" :key="child.text" class="wf-px-2 wf-flex-1">
          <div :class="titleClasses" :style="titleStyles">
            <span v-text="child.text"></span>  
          </div>
          <div class="wf-mt-3">
            <ul :class="classes" :style="styles">
              <li v-for="grandchild in child.children" :key="grandchild.text">
                <span class="wf-text-xs wf-font-bold" v-text="grandchild.text"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      fullWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      titleClasses: {
        type: [Array, String],
        required: true
      },
      titleStyles: {
        type: [Object, String],
        required: true
      },
      containerClasses: {
        type: [Array, String],
        required: true
      },
      containerStyles: {
        type: [Object, String],
        required: true
      },
      classes: {
        type: [Array, String],
        required: true
      },
      styles: {
        type: [Object, String],
        required: true
      },
      children: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        marginTop: 0
      }
    },
    watch: {
      containerClasses() {
        this.calculateMarginTop()
      },
      classes() {
        this.calculateMarginTop()
      }
    },
    mounted() {
      this.calculateMarginTop()
    },
    computed: {
      elementContainerClasses() {
        if (! this.fullWidth) {
          return this.containerClasses  
        }
        return this.containerClasses.filter(containerClass => containerClass.indexOf('mt') < 0)
      },
      elementContainerStyles() {
        if (! this.fullWidth) {
          return this.containerStyles  
        }
        let styles = {...this.containerStyles, width: '100%', left: 0, right: 0, bottom: 0, 'margin-bottom': `-${this.marginTop}px`}
        return styles
      }
    },
    methods: {
      calculateMarginTop() {
        if (! this.$refs['mega-menu']) {
          this.marginTop = 0
        }
        this.$nextTick(() => this.marginTop = this.$refs['mega-menu'].clientHeight)
      }
    },
  }
</script>